import { HighlightItem } from '@/types/highlights.interface'
import { ContainerBase } from './containers/ContainerBase'
import {
  Box,
  Text,
  useColorModeValue,
  VStack,
  SimpleGrid,
  Icon,
} from '@chakra-ui/react'

interface HighlightsProps {
  title: string
  description?: string
  items: HighlightItem[]
  columns: number
}

export const Highlights = ({
  title,
  description,
  items = [],
  columns,
}: HighlightsProps) => {
  const textColor = useColorModeValue('blackAlpha.700', 'whiteAlpha.700')
  const bg = useColorModeValue('whiteAlpha.50', 'whiteAlpha.200')

  return (
    <ContainerBase
      py={{ base: '42px', md: '100px' }}
      px={{ base: '32px', md: 4 }}
    >
      <VStack
        fontWeight="300"
        fontFamily="Space Grotesk"
        align="start"
        lineHeight="normal"
        gap="16px"
        mb="56px"
      >
        <VStack
          textAlign={{ base: 'center', md: 'start' }}
          align="start"
          lineHeight="normal"
        >
          <Text fontSize="40px">{title}</Text>
          <Text
            fontSize="24px"
            color={textColor}
            display={description ? 'block' : 'none'}
          >
            {description}
          </Text>
        </VStack>
      </VStack>
      <SimpleGrid columns={{ base: 1, md: 2, lg: columns }} gap="32px" w="full">
        {items.map((item, index) => (
          <VStack
            key={index}
            align={{ base: 'center', md: 'start' }}
            textAlign={{ base: 'center', md: 'start' }}
            gap="16px"
          >
            <Box
              p="16px"
              display="inline-flex"
              position="relative"
              bg={bg}
              _before={{
                zIndex: '1',
                content: '""',
                position: 'absolute',
                inset: '0',
                borderRadius: '8px',
                padding: '1.6px',
                background:
                  'linear-gradient(114deg, #0060FF 26.45%, #00FFBD 129.94%)',
                mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
                maskComposite: 'exclude',
              }}
              sx={{ '& > *': { zIndex: 2, position: 'relative' } }}
            >
              <Icon as={item.icon} boxSize="32px" />
            </Box>
            <Text fontSize="32px">{item.title}</Text>
            <Text fontSize="20px" color={textColor}>
              {item.description}
            </Text>
          </VStack>
        ))}
      </SimpleGrid>
    </ContainerBase>
  )
}
